// extracted by mini-css-extract-plugin
export default {"flags":"language_flags__h2l6n","flags_block":"language_flags_block__me3WE","active":"language_active__Ywu5v"};